import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.mountingPart || initialState;

export const selectMountingPart = createSelector(
  [selectSlice],
  state => state.data,
);
